import React, { useState, useEffect, useRef } from 'react';

import { /*reqGET, repo_img_link,*/ content_language, translate } from '../../../../Utils';

//import * as Hosts from "../../../../Hosts";

//import { language } from '../Language';

//import AssecImage from "../../ASSEC_Image/Image"

import parse from 'html-react-parser';

import Loader from '../../../../loader';
import "./HomeYoutubeVideo_01.css"

const HomeYoutubeVideo = (props) => {

	const [, set_dados] = useState(null)
	const video_list = useRef([])
	const dados_config = useRef([])

    const [video_title, set_video_title] = useState('')
    const [video_subtitle, set_video_subtitle] = useState('')

    const [isloading, setLoading] = useState(true);

    const [lang, set_lang] = useState(localStorage.getItem('lang'));
    const [/*lang_id*/, set_lang_id] = useState('1');

    useEffect(() => {

        if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
            set_dados(dados_config.current = props.dados_config)
            
            for (let el of dados_config.current.content[0].components) {

                if(el.info.tag === 'video' && el.info.active) {
                    set_video_title(translate(el.info.title, lang))
                    set_video_subtitle(translate(el.info.subtitle, lang))

                    set_dados(video_list.current = dados_config.current.content[0].video)
                    //set_dados(video_list.current.push(el))
                    setLoading(false)
                }
            }
        }

        if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_lang_id('1')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if (el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })
        }

    }, [props, lang])

    return (
        isloading ?
            <Loader />
		:
            <section id="homeYoutubeVideo_01">
                <div className="container">
                    <div className="row">
                        <div className="col-12 title-properties d-none">
                            <h3 className="titulo-pp">
                                {video_title}
                            </h3>
                            {
                                video_subtitle !== '' ?
                                    <h4 className={"subtitulo-pp"}>
                                        {video_subtitle}
                                    </h4>
                                :
                                    null
                            }
                            <hr></hr>
                        </div>
                        {
                            video_list.current !== undefined && video_list.current !== null && video_list.current.length > 0 ?
                                <div className="col-12">
                                    {
                                        video_list.current.map((v, k) => {
                                            return (
                                                <div className={"video-content"} key={k}>
                                                    {
                                                        (v.info.title !== undefined && translate(v.info.title, 'pt') !== '') || (v.info.subtitle !== undefined && translate(v.info.subtitle, 'pt') !== '') ?
                                                            <div className="title-properties">
                                                                {	
                                                                    v.info.title !== undefined && translate(v.info.title, 'pt') !== '' ?
                                                                        <h3 className="titulo-pp">
                                                                            {translate(v.info.title, 'pt')}
                                                                        </h3>
                                                                    :
                                                                        null
                                                                }
                                                                {	
                                                                    v.info.subtitle !== undefined && translate(v.info.subtitle, 'pt') !== '' ?
                                                                        <h4 className="subtitulo-pp">
                                                                            {translate(v.info.subtitle, 'pt')}
                                                                        </h4>
                                                                    :
                                                                        null
                                                                }
                                                                <hr></hr>
                                                            </div>
                                                        :
                                                            null
                                                    }
                                                    {
                                                        v.info.link !== undefined && v.info.link !== '' ?
                                                            <div className='iframe-youtube col-12 col-md-9 mx-auto mb-3 mb-md-5'>
                                                                <div className="ratio ratio-16x9">
                                                                    <iframe
                                                                        src={v.info.link.replace('watch?v=', 'embed/') + "?autoplay=0&mute=1&controls=1&loop=0"}
                                                                        title={v.info.title !== undefined && translate(v.info.title, 'pt') !== '' ? translate(v.info.title, 'pt'): 'YouTube video player'}
                                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                                        allowFullScreen>
                                                                    </iframe>
                                                                </div>
                                                            </div>
                                                        :
                                                            null
                                                    }
                                                    {	
                                                        v.info.text !== undefined && translate(v.info.text, 'pt') !== '' ?
                                                            <div className="video-description">
                                                                {parse(translate(v.info.text, 'pt'))}
                                                            </div>
                                                        :
                                                            null
                                                    }
                                                </div>
                                            )
                                        })              
                                    }
                                </div>
                            :
                            null
                        }
                    </div>
                </div>
            </section>
    )
};
export default HomeYoutubeVideo;